import NewBookingFlight from "./NewBookingFlight";

export default NewBookingFlight;
